import { FC, useState, createContext, useContext, useCallback } from 'react'
import { WithChildren } from '../../../../../../_metronic/helpers'
import {
  initialQueryRequestEscala,
  QueryRequestContextPropsPlantao,
  QueryStatePlantao,
} from './_models'

const QueryRequestContext =
  createContext<QueryRequestContextPropsPlantao>(initialQueryRequestEscala)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryStatePlantao>(initialQueryRequestEscala.state)

  const updateState = useCallback(
    (updates: Partial<QueryStatePlantao>) =>
      setState((prevState) => ({ ...prevState, ...updates })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
